import { render, staticRenderFns } from "./SelfService.vue?vue&type=template&id=0fcbd921"
import script from "./SelfService.vue?vue&type=script&lang=js"
export * from "./SelfService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports